<template>
  <b-overlay
      :show="loading"
      rounded="sm"
      class="user-status-report"
  >
    <b-card no-body>
      <b-card-body>
        <b-row>
          <b-col md="4">
            <div class="d-flex ">
              <div style="width:100px" class="mr-2">
                <p style="margin: 0">از تاریخ</p>
                <date-picker v-model="fromDate" />
              </div>
              <div style="width:100px" class="mr-2">
                <p style="margin: 0">تا تاریخ</p>
                <date-picker v-model="toDate" :min="fromDate" />
              </div>
              <div class="d-flex flex-column justify-content-end">
                <b-button
                    v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                    variant="info"
                    style="height:fit-content;width:85px"
                    @click="refreshData()"
                >
                  <span>اعمال</span>
                </b-button>
              </div>
            </div>
          </b-col>
          <b-col md="8">
            <b-table
                :items="statuses"
                :fields="productFlavors"
                responsive
                :no-local-sorting="true"
                borderless
                small
                class="rounded-bottom"
            >
              <template #cell()="data">
                <div class="text-center">
                  <b-button
                      v-if="data.field.key !== 'a'"
                      v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                      size="sm"
                      variant="outline-info"
                      @click="toggleReport($event, data)"
                  >
                    <span>
                      <BIconBarChartFill />
                    </span>
                  </b-button>
                  <span v-else>{{ data.item.key }}</span>
                </div>
              </template>
            </b-table>
          </b-col>
        </b-row>
        <h4 class="font-medium-3 mt-2">
          گزارش رشد وضعیت کاربر
        </h4>
        <vue-apex-charts
            key="user-status-growth-report"
            type="line"
            height="400"
            :options="activeUserGrowthOptions"
            :series="activeUserGrowthSeries"
        />

        <h4 class="font-medium-3 mt-3">
          گزارش شمارشی وضعیت کاربر
        </h4>
        <vue-apex-charts
            key="number-active-users-report"
            type="bar"
            height="400"
            :options="chartOptions"
            :series="numberActiveUsersSeries"
        />
      </b-card-body>
    </b-card>
  </b-overlay>
</template>

<script>
import {BCardHeader, BIconBarChartFill} from "bootstrap-vue";
import VueApexCharts from 'vue-apexcharts'

export default {
  name: "userStatusGrowthReport",
  components: {BIconBarChartFill, BCardHeader, VueApexCharts },
  data() {
    return {
      loading: false,
      fromDate: '',
      toDate: '',
      activeUserGrowthReport: [],
      numberActiveUsersReport: [],
      selectedReport: [],
      activeUserGrowthSeries: [],
      numberActiveUsersSeries: [],
      colors: ['#8ecae6', '#FD6A6A', '#775DD0', '#78c6a3', '#004e98', '#ffb4a2', '#D7263D', '#8D5B4C', '#3F51B5', '#F9A3A4', '#8D5B4C', '#E2C044', '#F9CE1D', '#F9A3A4', '#C7F464', '#00E396', '#81D4FA', '#662E9B', '#546E7A', '#C4BBAF', '#F86624', '#B6244F', '#e7c6ff', '#ffafcc', '#e07a5f', '#f72585', '#226f54', '#99c1b9']
    }
  },
  computed: {
    userGrowthReportObj() {
      let data = []
      this.activeUserGrowthReport.forEach(item => {
        let m = {
          date: item.CreateAt,
          markets: {}
        }
        item.Details.forEach(market => {
          m.markets[market.ProductFlavor] = {}
          market.ProductFlavorDetails.forEach(status => {
            m.markets[market.ProductFlavor][status.ActivationStatus] = status.Count
          })
        })
        data.push(m)
      })
      return data
    },
    numberActiveUsersReportObj() {
      let data = []
      this.numberActiveUsersReport.forEach(item => {
        let m = {
          date: item.CreateAt,
          markets: {}
        }
        item.Details.forEach(market => {
          m.markets[market.ProductFlavor] = {}
          market.ProductFlavorDetails.forEach(status => {
            m.markets[market.ProductFlavor][status.ActivationStatus] = status.Count
          })
        })
        data.push(m)
      })
      return data
    },
    productFlavors() {
      if (!this.activeUserGrowthReport.length) return []
      return ['a', ...this.activeUserGrowthReport[0].Details.map(item => item.ProductFlavor)]
    },
    statuses() {
      if (!this.activeUserGrowthReport.length) return []
      let items = this.activeUserGrowthReport[0].Details[0].ProductFlavorDetails || []
      return items.map(item => {
        return {
          key: item.ActivationStatus,
          value: item.Count,
        }
      })
    },
    activeUserGrowthOptions() {
      return {
        chart: {
          type: 'line',
          fontFamily: 'IranSans',
          toolbar: {
            show: false,
          },
        },
        dataLabels: {
          enabled: false
        },
        stroke: {
          width: 2,
          curve: 'straight',
          dashArray: [0, 0, 0]
        },
        markers: {
          size: 0,
          hover: {
            sizeOffset: 6
          }
        },
        tooltip: {
          followCursor: true,
          x: {
            show: false
          },
        },
        grid: {
          borderColor: '#f1f1f1',
        },
        colors: this.colors
      }
    },
    chartOptions() {
      return {
        chart: {
          type: 'bar',
          fontFamily: 'IranSans',
          toolbar: {
            show: false,
          },
        },
        plotOptions: {
          bar: {
            horizontal: false,
            columnWidth: '55%',
            endingShape: 'rounded'
          },
        },
        dataLabels: {
          enabled: false
        },
        fill: {
          opacity: 1
        },
        tooltip: {
          followCursor: true,
          x: {
            show: false
          },
        },
        colors: this.colors
      }
    }
  },
  created() {
    this.fromDate = this.$moment().startOf('jMonth').format('YYYY/MM/DD')
    this.toDate = this.$moment().endOf('jMonth').format('YYYY/MM/DD')
    this.refreshData()
  },
  methods: {
    refreshData() {
      this.loading = true
      this.$http.post(this.$api.report.userStatusGrowthReport, {
        FromDate: this.fromDate,
        ToDate: this.toDate,
      }).then(response => {
        this.activeUserGrowthReport = response.data.ActiveUserGrowthReport
        this.numberActiveUsersReport = response.data.NumberActiveUsersReport
        this.loading = false

      }).finally(() => { this.loading = false })
    },
    toggleReport(e, data) {
      let market = data.field.key
      let status = data.item.key
      let key = `${market}-${status}`
      let userGrowthItems = []
      let numberActiveUsersItems = []
      e.currentTarget.classList.toggle('btn-info')
      let index = this.selectedReport.findIndex(item => item === key)
      if (index === -1) {
        this.selectedReport.push(key)
        this.userGrowthReportObj.forEach(item => {
          userGrowthItems.push({
            x: this.$moment(item.date).format('jM/jD'),
            y: item.markets[market][status]
          })
        })
        this.numberActiveUsersReportObj.forEach(item => {
          numberActiveUsersItems.push({
            x: this.$moment(item.date).format('jM/jD'),
            y: item.markets[market][status]
          })
        })
        this.activeUserGrowthSeries.push({
          key: key,
          name: key,
          data: userGrowthItems
        })

        this.numberActiveUsersSeries.push({
          key: key,
          name: key,
          data: numberActiveUsersItems
        })
      }
      else {
        this.selectedReport.splice(index, 1)
        let reportItemIndex = this.activeUserGrowthSeries.findIndex(item => item.key === key)
        if (reportItemIndex !== -1) this.activeUserGrowthSeries.splice(reportItemIndex, 1)

        let reportItemIndex2 = this.numberActiveUsersSeries.findIndex(item => item.key === key)
        if (reportItemIndex2 !== -1) this.numberActiveUsersSeries.splice(reportItemIndex2, 1)
      }
    }
  }
}
</script>

<style lang="scss">
.user-status-report {
  .apexcharts-tooltip-marker {
    margin-right: 10px;
    margin-left: 0;
  }
  .apexcharts-tooltip-series-group {
    justify-content: right;
  }
}

</style>